import { createEntity, request } from '@luna/api';
import type { ExportPreferenceTab, ExportTabTypes } from '@shared/export-center';
import { getEnv } from '@luna/env';
import { createQueryString } from '@luna/router';
import { deepClean } from '@luna/utils';

import type { ExportPreferenceTabsResponse } from '../types';

interface Params {
    type?: ExportTabTypes[];
}

const { useEntities: useExportPreferenceTabs } = createEntity({
    name: 'export/preferences/tabs',
    withEntityType: {} as ExportPreferenceTab,
    payloadCreators: {
        queryAll: async ({ type = [] }: Params = {}) => {
            const queryString = createQueryString(deepClean({ type }));
            const url = `${getEnv().apiGatewayUrl}export-center/public/preferences/tabs${queryString}`;

            const response = await request<ExportPreferenceTabsResponse>(url);
            return response.tabs ?? [];
        },
    },
});

export { useExportPreferenceTabs };
